import { Form, Input } from 'antd';
import React, { ChangeEvent, useCallback, useState } from 'react';
import { buttonStyle } from './styles';
import { onlyLatinCharsDigitsSpecialSymbolsRule } from '../../../../utils/form.constants';

export const ConfirmPasswordForms = () => {
  // TODO: Rework to uncontrolled using antd watch form value method
  const [value, setValue] = useState('');

  const onChange = useCallback(({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    setValue(value.toString());
  }, []);

  const shouldValidate = value.length >= 6;

  return (
    <>
      <Form.Item
        name='password'
        rules={[
          onlyLatinCharsDigitsSpecialSymbolsRule,
          {
            required: true,
            message: 'Please enter your password.',
            whitespace: true,
          },
          ({ getFieldValue }) => ({
            validator() {
              if (getFieldValue('password').length >= 6) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('6 characters at least'));
            },
          }),
        ]}
        validateTrigger={'onChange'}
        initialValue=''
        hasFeedback={shouldValidate}
      >
        <Input.Password
          onChange={onChange}
          placeholder='Password (6 digits at least, case sensitive)'
          size='large'
          style={{ ...buttonStyle }}
        />
      </Form.Item>
      <Form.Item
        name='confirm'
        dependencies={['password']}
        hasFeedback={shouldValidate}
        rules={[
          onlyLatinCharsDigitsSpecialSymbolsRule,
          {
            required: true,
            message: 'Please confirm your password!',
            whitespace: true,
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('The two passwords that you entered do not match!'));
            },
          }),
        ]}
        validateTrigger={'onChange'}
      >
        <Input.Password placeholder='Confirm password' size='large' style={{ ...buttonStyle }} />
      </Form.Item>
    </>
  );
};
